module.exports = __webpack_public_path__ + "static/fshmNewsImage-66d7d8bb0087f8ac182561326e12be13.png";